import Skeleton from '@srm/ui/skeleton';
import './DashboardSkeleton.scss';

// Abstract content blocks: the user's widget types and layout are still unknown.
const DashboardSkeleton = () => (
    <div className="dashboard-skeleton" role="status" aria-label="Загрузка дашборда" aria-busy="true">
        <div className="dashboard-skeleton__visual" aria-hidden="true">
            {[0, 1, 2, 3].map((key) => (
                <div className="dashboard-skeleton__block" key={key}>
                    <Skeleton height={12} width="28%" radius="sm" />
                    <Skeleton className="dashboard-skeleton__surface" height={112} radius={12} />
                    <Skeleton height={10} width="64%" radius="sm" />
                </div>
            ))}
        </div>
    </div>
);

export default DashboardSkeleton;
